var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from "classnames";
import React from "react";
import { Popup } from "react-map-gl";
export const MapPopup = _a => {
  var longitude = _a.longitude,
    latitude = _a.latitude,
    closeButton = _a.closeButton,
    onClose = _a.onClose,
    className = _a.className,
    _a$anchor = _a.anchor,
    anchor = _a$anchor === void 0 ? "top" : _a$anchor,
    _a$offset = _a.offset,
    offset = _a$offset === void 0 ? [0, 5] : _a$offset,
    children = _a.children,
    _a$showBeak = _a.showBeak,
    showBeak = _a$showBeak === void 0 ? true : _a$showBeak,
    props = __rest(_a, ["longitude", "latitude", "closeButton", "onClose", "className", "anchor", "offset", "children", "showBeak"]);
  const popupStyles = classNames("!max-w-sm px-4 [&>.mapboxgl-popup-content]:rounded-xl [&>.mapboxgl-popup-content]:border [&>.mapboxgl-popup-content]:border-neutral-300 [&>.mapboxgl-popup-content]:p-6 [&>.mapboxgl-popup-content]:shadow-xl z-[3]", "[&>.mapboxgl-popup-tip]:-mb-2.5 [&>.mapboxgl-popup-tip]:!border-0 [&>.mapboxgl-popup-tip]:!border-b [&>.mapboxgl-popup-tip]:!border-l [&>.mapboxgl-popup-tip]:!border-neutral-300 [&>.mapboxgl-popup-tip]:!bg-white [&>.mapboxgl-popup-tip]:!bg-white [&>.mapboxgl-popup-tip]:!w-5 [&>.mapboxgl-popup-tip]:!h-5 [&>.mapboxgl-popup-tip]:rotate-[135deg]", !showBeak && "[&>.mapboxgl-popup-tip]:!hidden", className);
  return /*#__PURE__*/React.createElement(Popup, Object.assign({
    offset: offset,
    closeButton: closeButton,
    className: popupStyles,
    anchor: anchor,
    longitude: longitude,
    latitude: latitude,
    onClose: onClose
  }, props), children);
};